<template>
    <div class="af-apply-with-option af-apply-with-linkedin">
        <div
            class="afu-p-5 afu-flex afu-items-center afu-justify-center afu-shadow-btn afu-rounded afu-bg-white afu-cursor-pointer afu-border afu-border-solid afu-border-transparent hover:afu-border-solid hover:afu-border hover:afu-border-secondary-light"
            @click="signInLinkedin"
        >
            <img
                :src="getLogo"
                alt="Apply with linkedin"
            >
            <span
                class="afu-text-base afu-w-40 afu-font-semibold afu-ml-2 afu-font-sans"
            >
                Continue with Linkedin
            </span>
        </div>
    </div>
</template>

<script>
    import Cookie from '@/services/cookie';
    import { mapActions } from 'vuex';
    import LinkedInMixin from '@/components/Social/LinkedInMixin';

    export default {
        name: 'AuthLinkedIn',

        components: {},

        mixins: [LinkedInMixin],

        props: {},

        data() {
            return {
                password: '',
                response: {
                    message_title: '',
                    message: '',
                },
                spinner: {
                    register: false,
                },
            };
        },

        methods: {
            ...mapActions('me', {
                $_storeAllUserData: 'storeAllUserData',
            }),

            afterLogin(data) {
                if (data.access_token) {
                    this.$_storeAllUserData(data);
                    Cookie.setToken(data.access_token);
                    window.location.href = '/user-dashboard';
                } else {
                    Cookie.setOauthInfo(data.data);
                    window.location.href = '/user-register';
                }
            },
        },
    };
</script>
